var activeTabClass = 'current';

$('.js-tabs .js-tab-link').on('click', function(e) {
  e.preventDefault();

  var $tabLink = $(this);
  var $targetTab = $($tabLink.attr('href'));

  $tabLink
    .parent()
    .add($targetTab)
    .addClass(activeTabClass)
    .siblings()
    .removeClass(activeTabClass);
});

customTabsChange();

function locationHashChanged(e) {
  customTabsChange();
}

window.onhashchange = locationHashChanged;

function customTabsChange() {
  if ($('.js-tabs--custom').length) {
    const pathname = window.location.pathname;
    const url = window.location.href;

    const urlLastPart = url
      .split(pathname)
      .pop()
      .replace('#', '');

    const $tabLoad = $('.js-tabs .tab#tab-' + urlLastPart + '');
    const $tabLinkLoad = $('.js-tabs .js-tab-link[href="#tab-' + urlLastPart + '"]');

    if ($tabLoad.length) {
      $tabLoad
        .addClass(activeTabClass)
        .siblings()
        .removeClass(activeTabClass);
    }

    if ($tabLinkLoad.length) {
      $tabLinkLoad
        .parent()
        .addClass(activeTabClass)
        .siblings()
        .removeClass(activeTabClass);
    }
  }
}



// WEBPACK FOOTER //
// ./../src/assets/js/customTabs.js